import React from 'react';
import T from 'prop-types';

import { H1 } from 'components/common/headers';

export default class ReportConfigHeader extends React.Component {
  render() {
    const { config, renderSecondaryElements } = this.props;

    return (
      <div className="reportHeader">
        <div className="reportHeader-infoWithLink">
          <div className="reportHeader-titleWithlink">
            <H1>{config.title}</H1>
            <a className="reportHeader-help" href={getHelpDocUrlSlug(config.urlSlug)} target="_blank" rel="noreferrer">
              Read our guide for this report
            </a>
          </div>
          {renderSecondaryElements()}
        </div>
      </div>
    );
  }
}

// special case for IVR - all IVR urls should send the user to the same IVR help doc
function getHelpDocUrlSlug(urlSlug) {
  if (urlSlug.includes('ivr-')) {
    urlSlug = 'ivr';
  }

  return `https://help.gladly.com/docs/${urlSlug}/`;
}

ReportConfigHeader.propTypes = {
  config: T.object.isRequired,
  renderSecondaryElements: T.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/reporting/report_config_header.jsx